"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
  _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "RenderFields", {
  enumerable: !0,
  get: function get() {
    return _RenderFields["default"];
  }
}), Object.defineProperty(exports, "FormError", {
  enumerable: !0,
  get: function get() {
    return _FormError["default"];
  }
}), Object.defineProperty(exports, "FormConfirmation", {
  enumerable: !0,
  get: function get() {
    return _FormConfirmation["default"];
  }
}), Object.defineProperty(exports, "validateField", {
  enumerable: !0,
  get: function get() {
    return _validation.validateField;
  }
}), Object.defineProperty(exports, "Submit", {
  enumerable: !0,
  get: function get() {
    return _Submit["default"];
  }
}), exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
  _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
  _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
  _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
  _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
  _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized")),
  _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
  _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
  _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
  _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
  _react = _interopRequireWildcard(require("react")),
  _isomorphicUnfetch = _interopRequireDefault(require("isomorphic-unfetch")),
  _RenderFields = _interopRequireDefault(require("./FormElements/RenderFields")),
  _FormError = _interopRequireDefault(require("./FormElements/FormError")),
  _FormConfirmation = _interopRequireDefault(require("./FormElements/FormConfirmation")),
  _validation = require("./Helpers/validation"),
  _utils = require("./Helpers/utils"),
  _Submit = _interopRequireDefault(require("./FormElements/Submit"));
function _createForOfIteratorHelper(a, b) {
  var c;
  if ("undefined" == typeof Symbol || null == a[Symbol.iterator]) {
    if (Array.isArray(a) || (c = _unsupportedIterableToArray(a)) || b && a && "number" == typeof a.length) {
      c && (a = c);
      var d = 0,
        e = function e() {};
      return {
        s: e,
        n: function n() {
          return d >= a.length ? {
            done: !0
          } : {
            done: !1,
            value: a[d++]
          };
        },
        e: function e(a) {
          throw a;
        },
        f: e
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var f,
    g = !0,
    h = !1;
  return {
    s: function s() {
      c = a[Symbol.iterator]();
    },
    n: function n() {
      var a = c.next();
      return g = a.done, a;
    },
    e: function e(a) {
      h = !0, f = a;
    },
    f: function f() {
      try {
        g || null == c["return"] || c["return"]();
      } finally {
        if (h) throw f;
      }
    }
  };
}
function _unsupportedIterableToArray(a, b) {
  if (a) {
    if ("string" == typeof a) return _arrayLikeToArray(a, b);
    var c = Object.prototype.toString.call(a).slice(8, -1);
    return "Object" === c && a.constructor && (c = a.constructor.name), "Map" === c || "Set" === c ? Array.from(a) : "Arguments" === c || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray(a, b) : void 0;
  }
}
function _arrayLikeToArray(a, b) {
  (null == b || b > a.length) && (b = a.length);
  for (var c = 0, d = Array(b); c < b; c++) d[c] = a[c];
  return d;
}
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    (0, _defineProperty2["default"])(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
function _createSuper(a) {
  var b = _isNativeReflectConstruct();
  return function () {
    var c,
      d = (0, _getPrototypeOf2["default"])(a);
    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);
    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}
function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}
var GravityForm = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "getFieldPrepopulatedValue", function (a, b, c) {
      var d,
        e = !1,
        f = a.inputName && b && b[a.inputName];
      if (c && c[a.id] ? e = !0 : c && a.inputs && a.inputs.some(function (a) {
        c[a.id] && (e = !0);
      }), "checkbox" === a.type) d = a.choices.filter(function (c) {
        return f ? c.value === b[a.inputName] : c.isSelected;
      }).map(function (a) {
        return a.value;
      }), e && (d = a.inputs.filter(function (a) {
        return c[a.id];
      }).map(function (a) {
        return a.label;
      }));else if ("radio" === a.type) {
        if (f) d = b[a.inputName];else {
          var g = a.choices.find(function (a) {
            return a.isSelected;
          });
          d = g ? g.value : "";
        }
      } else if ("select" === a.type) {
        var h = a.choices.filter(function (c) {
          return f ? c.value === b[a.inputName] : c.isSelected;
        }).map(function (a) {
          return {
            value: a.value,
            label: a.text
          };
        });
        d = h && 0 < h.length ? h[0] : "";
      } else d = f ? b[a.inputName] : e ? c[a.id] : a.defaultValue;
      return d;
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "updateFieldsValuesBasedOnEntry", function (a) {
      for (var b, c = d.state, e = c.formValues, f = c.formData, g = Object.keys(e), h = !1, j = _objectSpread({}, e), k = function k(b) {
          var c = g[b];
          if (a[c]) {
            var i = f.fields.filter(function (a) {
              return a.id == c;
            });
            if (!i[0]) return "continue";
            var k = d.getFieldPrepopulatedValue(i[0], [], a);
            k && e[c] && e[c].value && e[c].value != k && (j[c].value = k, h = !0);
          }
        }, l = 0; l < g.length; l++) b = k(l), "continue" === b;
      h && d.setState({
        formValues: j
      });
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "setTouched", function (a) {
      d.setState({
        touched: _objectSpread(_objectSpread({}, d.state.touched), {}, (0, _defineProperty2["default"])({}, a, !0))
      });
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "unsetError", function (a) {
      var b = d.state.errorMessages;
      !b || b[a] && (delete b[a], d.setState({
        errorMessages: b
      }));
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "checkInputMaskValue", function (a, b) {
      var c,
        e = b.inputMaskValue,
        f = b.inputMask;
      if (!e || !f) return a;
      var g = d.state.formatChars,
        h = [];
      null === (c = e.split("")) || void 0 === c ? void 0 : c.map(function (a) {
        g[a] ? h.push(new RegExp(g[a])) : h.push(null);
      });
      var i = 0 < h.length && a.split("").every(function (a, b) {
        return null === h[b] || h[b].test(a);
      });
      return i ? a : "";
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "updateFormHandler", function (a, b) {
      var c,
        e = !!(2 < arguments.length && void 0 !== arguments[2]) && arguments[2],
        f = d.state,
        g = f.formValues,
        h = f.conditioanlIds,
        j = f.conditionFields,
        k = b.id,
        l = b.type,
        m = b.isRequired;
      if ("checkbox" === b.type) {
        var n = (0, _toConsumableArray2["default"])(g[b.id].value),
          o = n.indexOf(a.target.value);
        -1 < o ? n.splice(o, 1) : n.push(a.target.value), c = n;
      } else if ("date" == b.type && "datepicker" !== b.dateType) {
        var p = b.subId,
          q = b.dateLabel,
          r = (0, _toConsumableArray2["default"])(g[b.id].value);
        r[p] = {
          val: a.target.value,
          label: q
        }, c = r;
      } else if ("consent" == b.type) c = a.target ? a.target.checked : "null";else if ("password" === b.type || "email" === b.type && b.emailConfirmEnabled) {
        var s = b.subId,
          t = g[b.id] && g[b.id].value ? (0, _toConsumableArray2["default"])(g[b.id].value) : [];
        t[s] = {
          val: a.target.value
        }, c = t;
      } else c = a.target ? a.target.value : "null";
      "text" === l && -1 < b.cssClass.indexOf("iban") && (l = "iban");
      var u = b.customValidateField ? b.customValidateField(c, b) : (0, _validation.validateField)(c, b);
      if (-1 !== h.indexOf(k)) {
        g[k].value = c;
        for (var x = 0; x < j.length; x++) {
          var v = j[x].id,
            w = d.checkConditionalLogic(j[x].conditionalLogic, g);
          g[v].hideField = w;
        }
      }
      c = e ? d.checkInputMaskValue(c, b) : c, console.log("formValues", g), d.setState({
        formValues: _objectSpread(_objectSpread({}, g), {}, (0, _defineProperty2["default"])({}, k, {
          value: c,
          id: k,
          valid: u,
          label: b.label,
          pageNumber: b.pageNumber,
          cssClass: b.cssClass,
          isRequired: b.isRequired
        }))
      }, function () {
        var a = d.props,
          e = a.onChange,
          f = a.onChangeField;
        e && e(d.state.formValues), f && f((0, _defineProperty2["default"])({}, k, {
          value: c,
          id: k,
          valid: u,
          label: b.label,
          pageNumber: b.pageNumber,
          cssClass: b.cssClass,
          isRequired: b.isRequired
        }));
      });
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "scrollToConfirmation", function () {
      var a = d.props,
        b = a.onChangePage,
        c = a.jumpToConfirmation;
      if (b && b(), c) {
        var e = !!d.wrapperRef && d.wrapperRef.getBoundingClientRect();
        if (e && window) {
          var f = window.pageYOffset || document.documentElement.scrollTop;
          window.scrollTo({
            top: f + e.top - 100
          });
        }
      }
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "onSubmit", function () {
      var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
        var c, e, f, g, h, i, j, k, l;
        return _regenerator["default"].wrap(function (a) {
          for (;;) switch (a.prev = a.next) {
            case 0:
              c = d.props.onSubmit, e = new FormData(b.target), b.preventDefault(), c ? c(e) : (d.setState({
                submitting: !0,
                submitSuccess: !1,
                submitFailed: !1,
                confirmationMessage: !1,
                errorMessages: !1
              }), f = d.props, g = f.formID, h = f.backendUrl, i = f.jumpToConfirmation, j = f.onSubmitSuccess, k = f.onError, l = h.substring(0, h.indexOf("/wp-json")), (0, _isomorphicUnfetch["default"])("".concat(l, "/wp-json/gf/v2/forms/").concat(g, "/submissions"), {
                method: "POST",
                body: e
              }).then(function (a) {
                return a.json();
              }).then(function (a) {
                if (a && a.is_valid) {
                  if (j) {
                    var g = j(a);
                    if (!g) return !1;
                  }
                  var b = a || !1,
                    c = b.confirmation_message,
                    e = b.confirmation_redirect,
                    f = b.confirmation_type;
                  if (f && e && "redirect" === f && "undefined" != typeof window) return window.location.replace(e), !1;
                  d.setState({
                    submitting: !1,
                    submitSuccess: !0,
                    confirmationMessage: c
                  }), i && d.scrollToConfirmation();
                } else throw {
                  response: a
                };
              })["catch"](function (a) {
                var b = a && a.response && a.response.validation_messages ? a.response.validation_messages : "Something went wrong";
                k ? (k(b), d.setState({
                  submitting: !1,
                  submitFailed: !0
                })) : d.setState({
                  submitting: !1,
                  submitFailed: !0,
                  errorMessages: b
                }), i && d.scrollToConfirmation();
              }));
            case 4:
            case "end":
              return a.stop();
          }
        }, a);
      }));
      return function () {
        return a.apply(this, arguments);
      };
    }()), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "getNextStep", function (a) {
      var b = d.state,
        c = b.formValues,
        e = b.pages,
        f = a + 1,
        g = e[a - 1];
      return !!c[g] && (!0 === c[g].hideField && (f = d.getNextStep(f)), f);
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "getPrevStep", function (a) {
      var b = d.state,
        c = b.formValues,
        e = b.pages,
        f = a - 1,
        g = e[a - 3] || 0;
      return c[g] && !0 === c[g].hideField && (f = d.getPrevStep(f)), f;
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "nextStep", function (a) {
      a && a.preventDefault();
      var b = d.state,
        c = b.activePage,
        e = b.formValues,
        f = d.props,
        g = f.activePage,
        h = f.beforeNextPage,
        i = d.getNextStep(c);
      h && h(c, e, i), g && g(i), d.setState({
        activePage: i,
        pageClicked: !0
      }, function () {
        return d.scrollToConfirmation();
      });
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "prevStep", function (a) {
      a && a.preventDefault();
      var b = d.state.activePage,
        c = d.props.activePage,
        e = d.getPrevStep(b) || 1;
      c && c(e), d.setState({
        activePage: e,
        pageClicked: !0
      }, function () {
        return d.scrollToConfirmation();
      });
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "checkConditionalLogic", function (a) {
      var b = !!(1 < arguments.length && void 0 !== arguments[1]) && arguments[1],
        c = a.rules,
        e = a.actionType;
      if (!c) return !0;
      for (var f = b || d.state.formValues, g = "hide" !== e, h = [], j = 0; j < c.length; j++) {
        var k = c[j],
          l = k.fieldId,
          m = k.value,
          n = k.operator,
          o = f[l].value && f[l].value.value ? f[l].value.value : f[l].value || !1,
          p = Array.isArray(o) ? o.join("") : o;
        h[j] = m ? p && m == p ? "hide" === e : p && p.includes(m) ? "hide" === e : "hide" !== e : p || m ? "hide" !== e : "hide" === e, "isnot" === n && (h[j] = !h[j]);
      }
      return g = h.every(function (a) {
        return !0 === a;
      }), g;
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "isFieldDisabled", function (a) {
      var b = d.state.formData,
        c = Object.keys(a),
        e = c.some(function (d) {
          if (b && b.pagination) {
            var e = a[d].pageNumber,
              f = c.filter(function (b) {
                return "page" === a[b].type && a[b].pageNumber == e;
              });
            if (f && 0 < f.length) return !a[d].hideField && a[d].valid && !a[f[0]].hideField;
          }
          return !a[d].hideField && a[d].valid;
        });
      return e;
    }), d.state = {
      submitFailed: !1,
      errorMessages: !1,
      formValues: {},
      loading: !0,
      submitting: !1,
      submitSuccess: !1,
      confirmationMessage: !1,
      isValid: !1,
      formData: {},
      touched: {},
      activePage: !1,
      conditionFields: {},
      conditioanlIds: {},
      isMultipart: !1,
      pageClicked: !1,
      formatChars: {
        9: "[0-9]",
        a: "[A-Za-z]",
        "*": "[A-Za-z0-9]",
        A: "[A-Z]"
      }
    }, d;
  }
  (0, _inherits2["default"])(b, a);
  var c = _createSuper(b);
  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function () {
      var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
        var b,
          c,
          d,
          e,
          f,
          g,
          h,
          j,
          k,
          l,
          m,
          n,
          o,
          p,
          q,
          r,
          s,
          t,
          u,
          v,
          w,
          x,
          y,
          z,
          A,
          B = this;
        return _regenerator["default"].wrap(function (a) {
          for (;;) switch (a.prev = a.next) {
            case 0:
              return b = this.props, c = b.formID, d = b.backendUrl, e = b.populatedFields, f = b.populatedEntry, g = b.fetchOptions, h = b.initialPage, j = b.getParams, this._isMounted = !0, k = !1, l = j ? Object.keys(j).map(function (a) {
                return "".concat(a, "=").concat(j[a]);
              }).join("&") : "", m = "".concat(d, "/").concat(c).concat(l ? "?".concat(l) : ""), a.next = 7, (0, _isomorphicUnfetch["default"])(m, g).then(function (a) {
                return a.json();
              }).then(function (a) {
                return a;
              })["catch"](function () {
                return !1;
              });
            case 7:
              if (n = a.sent, n && this._isMounted) {
                o = {}, p = [], q = [], r = [], s = _createForOfIteratorHelper(n.fields);
                try {
                  for (s.s(); !(t = s.n()).done;) {
                    if (u = t.value, v = void 0, "page" === u.type && r.push(u.id), v = this.getFieldPrepopulatedValue(u, e, f), "fileupload" === u.type && (k = !0), u.conditionalLogic) {
                      for (w = {
                        id: u.id,
                        conditionalLogic: u.conditionalLogic
                      }, x = u.conditionalLogic.rules.map(function (a) {
                        return a.fieldId;
                      }), y = 0; y < x.length; y++) z = parseInt(x[y]), -1 === q.indexOf(z) && q.push(z);
                      p.push(w);
                    }
                    o[u.id] = {
                      valid: u.customValidateField ? u.customValidateField(v, u) : (0, _validation.validateField)(v, u),
                      value: v,
                      label: u.label,
                      pageNumber: u.pageNumber,
                      cssClass: u.cssClass,
                      isRequired: u.isRequired,
                      type: u.type
                    };
                  }
                } catch (a) {
                  s.e(a);
                } finally {
                  s.f();
                }
                for (A = 0; A < p.length; A++) o[p[A].id].hideField = this.checkConditionalLogic(p[A].conditionalLogic, o);
                this.setState({
                  formData: n,
                  formValues: o,
                  activePage: h || !!n.pagination && 1,
                  conditionFields: p,
                  conditioanlIds: q,
                  isMultipart: k,
                  pages: r,
                  populatedEntry: f || !1
                }, function () {
                  var a = B.props,
                    b = a.nextStep,
                    c = a.prevStep,
                    d = a.activePage;
                  b && b(function () {
                    return B.nextStep;
                  }), c && c(function () {
                    return B.prevStep;
                  }), d && d(B.state.activePage);
                });
              }
            case 9:
            case "end":
              return a.stop();
          }
        }, a, this);
      }));
      return function componentDidMount() {
        return a.apply(this, arguments);
      };
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(a) {
      var b = this.props,
        c = b.populatedEntry,
        d = b.initialPage,
        e = a.populatedEntry;
      c && e && !(0, _utils.equalShallow)(c, e) && this.updateFieldsValuesBasedOnEntry(c), d && d !== this.state.activePage && this.setState({
        activePage: d
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = !1;
    }
  }, {
    key: "render",
    value: function render() {
      var a = this,
        b = this.state,
        c = b.formData,
        d = b.formValues,
        e = b.submitFailed,
        f = b.submitSuccess,
        g = b.touched,
        h = b.submitting,
        i = b.activePage,
        j = b.isMultipart,
        k = b.pageClicked,
        l = this.props,
        m = l.title,
        n = l.submitIcon,
        o = l.saveStateToHtmlField,
        p = l.styledComponents,
        q = l.customComponents,
        r = l.errorMessage,
        s = l.dropzoneText,
        t = l.loadingSpinner,
        u = l.onError,
        v = p || !1,
        w = v.Button,
        x = v.Loading,
        y = v.GFWrapper,
        z = void 0 === y ? "div" : y,
        A = v.FormError,
        B = v.FormConfirmation,
        C = c.cssClass,
        D = this.isFieldDisabled(d),
        E = !!i && Object.keys(d).some(function (a) {
          return d[a].pageNumber === i && !d[a].hideField && d[a].valid;
        });
      return _react["default"].createElement(z, {
        ref: function ref(b) {
          return a.wrapperRef = b;
        },
        className: "form-wrapper",
        css: {
          position: "relative"
        },
        id: "gravity_form_".concat(this.props.formID)
      }, c.title ? null : x && _react["default"].createElement(x, {
        isLoading: !0
      }), e && !f && !u && _react["default"].createElement(_FormError["default"], {
        SFormError: A || !1,
        errorMessage: r || "There was a problem with your submission"
      }), f && this.state.confirmationMessage && _react["default"].createElement(_FormConfirmation["default"], {
        confirmation: this.state.confirmationMessage,
        SFormConfirmation: B
      }), !f && c.fields ? _react["default"].createElement("form", {
        onSubmit: function onSubmit(b) {
          return a.onSubmit(b);
        },
        className: C,
        encType: j ? "multipart/form-data" : void 0,
        noValidate: !0
      }, (c.title || c.description) && _react["default"].createElement(_react["default"].Fragment, null, c.title && m && _react["default"].createElement("h3", {
        className: "form-title"
      }, c.title), c.description ? _react["default"].createElement("div", {
        className: "form-description"
      }, _react["default"].createElement("p", {
        dangerouslySetInnerHTML: {
          __html: c.description
        }
      })) : null), _react["default"].createElement("div", {
        className: "form-wrapper"
      }, _react["default"].createElement(_RenderFields["default"], {
        styledComponents: p,
        customComponents: q,
        fields: c.fields,
        formValues: d,
        submitFailed: e,
        submitSuccess: f,
        updateForm: this.updateFormHandler,
        touched: g,
        setTouched: this.setTouched,
        pagination: c.pagination,
        activePage: i,
        prevStep: this.prevStep,
        nextStep: this.nextStep,
        isNextDisabled: E,
        checkConditionalLogic: this.checkConditionalLogic,
        saveStateToHtmlField: o,
        enableHoneypot: c.enableHoneypot,
        errors: this.state.errorMessages,
        unsetError: this.unsetError,
        dropzoneText: s,
        pageClicked: k,
        formatChars: this.state.formatChars
      }), (!c.pagination || c.pagination && c.pagination.pages.length === i) && _react["default"].createElement(_Submit["default"], {
        Button: w,
        Loading: x,
        formData: c,
        submitIcon: n,
        isDisabled: D,
        submitting: h,
        prevStep: this.prevStep,
        loadingSpinner: t
      }))) : "");
    }
  }]), b;
}(_react.Component);
GravityForm.defaultProps = {
  title: !0,
  submitIcon: !1,
  saveStateToHtmlField: !1,
  jumpToConfirmation: !0
};
var _default = GravityForm;
exports["default"] = _default;